import { useIsFetching, useQueryClient } from "@tanstack/react-query";
import {
  Button,
  Icon,
  IconLoading,
  useToast,
} from "@validereinc/common-components";
import React from "react";

const toastId = "global-refresh";

export const GlobalRefreshTrigger = () => {
  const numOfQueriesFetching = useIsFetching();
  const queryClient = useQueryClient();
  const { toast } = useToast();

  const isFetching = numOfQueriesFetching > 0;

  return (
    <Button
      slotLeft={
        isFetching ? (
          <IconLoading
            speed="fast"
            size={18}
          />
        ) : (
          <Icon
            variant="arrow-counter-clockwise"
            size={18}
          />
        )
      }
      size="xx-small"
      variant="outline"
      title="Refresh Data"
      isLoading={isFetching}
      onClick={() => {
        queryClient
          .refetchQueries({
            predicate: (query) => !query.queryKey.includes("auth"),
            type: "active",
          })
          .then(() => {
            return toast.push(
              {
                intent: "success",
                title: "Data refreshed successfully",
                description: "Everything visible is up to date.",
              },
              { id: toastId, duration: 3000 }
            );
          })
          .catch(({ id: toastId }) => {
            toast.push(
              {
                intent: "error",
                title: "Failed to refresh data",
                description: "An error occurred while refreshing data.",
              },
              { id: toastId, duration: 5000 }
            );
          });
      }}
    />
  );
};
